export enum AvoirsPath {
  ROOT = '',
  EDITION = 'edition',
  GENERAL = 'general',
  ID_AVOIR_PARAM = 'idAvoir',
}
